import * as z from "zod";

export const setOkendoIntegration = {
  name: "setOkendoIntegration" as const,
  input: z.object({ okendoUserId: z.string() }),
  output: z.null(),
};

export type SetOkendoIntegrationInput = z.infer<
  typeof setOkendoIntegration.input
>;
